import {
  Component,
  inject,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { TitleComponent } from '../content-desktop/components/title/title.component';
import { MobileSpaceComponent } from './components/mobile-space/mobile-space.component';
import { takeWhile } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CategoryComponent } from '../content-desktop/components/category/category.component';

@Component({
  selector: 'div[raHeaderMobile]',
  standalone: true,
  imports: [CommonModule, TitleComponent, CategoryComponent],
  templateUrl: './content-mobile.component.html',
  styleUrls: ['./content-mobile.component.scss'],
})
export class ContentMobileComponent {
  @ViewChild('MobileSpace', { read: ViewContainerRef })
  private viewMobileSpace!: ViewContainerRef;

  menuToggle = false;
  alive = true;
  private _platformId = inject(PLATFORM_ID);

  constructor(private router: Router) {}

  toggleMenu() {
    this.menuToggle = !this.menuToggle;
    switch (this.menuToggle) {
      case true:
        if (isPlatformBrowser(this._platformId)) {
          window.scrollTo(0, 0);
          setTimeout(() => {
            window.scroll({ top: -1, left: 0, behavior: 'smooth' });
          }, 10);
          this.openMobileSpace();
        }
        return;
      case false:
        this.closeMobileSpace();
        return;
    }
  }

  openMobileSpace() {
    this.viewMobileSpace.clear();
    this.alive = true;
    const mobileSpaceComp =
      this.viewMobileSpace.createComponent(MobileSpaceComponent);
    mobileSpaceComp.instance.closeSelf
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => {
        this.viewMobileSpace.clear();
        this.menuToggle = false;
        this.alive = false;
      });
  }

  closeMobileSpace() {
    this.viewMobileSpace.clear();
  }
}
